import JsonLd from '../JsonLd';

const QuizSchema: React.FC = () => {
  const quizData = {
    "@context": "https://schema.org",
    "@type": "Quiz",
    "name": "Board AI Oversight Assessment",
    "description": "A 5-minute assessment that benchmarks board AI oversight readiness and identifies priority governance gaps—plus recommended next steps.",
    "url": "https://boardsight.ai/quiz",
    "provider": {
      "@type": "Organization",
      "name": "BoardSight AI",
      "url": "https://boardsight.ai"
    },
    "about": {
      "@type": "Thing",
      "name": "AI Governance Readiness"
    },
    "educationalLevel": "Executive",
    "audience": {
      "@type": "Audience",
      "audienceType": "Board Directors, Corporate Governance Professionals"
    },
    "numberOfQuestions": 10,
    "timeRequired": "PT5M",
    "isAccessibleForFree": true
  };

  // Also add HowTo schema for the assessment process
  const howToData = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How to Benchmark Your Board's AI Oversight Readiness",
    "description": "A 5-minute diagnostic designed for directors and board-facing leaders to identify oversight gaps and recommended next steps.",
    "totalTime": "PT5M",
    "step": [
      {
        "@type": "HowToStep",
        "position": 1,
        "name": "Start the Assessment",
        "text": "Begin the AI oversight assessment by clicking 'Begin Assessment' on the quiz page."
      },
      {
        "@type": "HowToStep",
        "position": 2,
        "name": "Answer Oversight Questions",
        "text": "Answer questions covering oversight structure, AI visibility, risk ownership, reporting cadence, incident readiness, vendor oversight, and assurance readiness."
      },
      {
        "@type": "HowToStep",
        "position": 3,
        "name": "Review Your Maturity Score",
        "text": "Receive your AI Oversight Maturity Score with identified strengths and gaps."
      },
      {
        "@type": "HowToStep",
        "position": 4,
        "name": "Get Your Roadmap",
        "text": "Receive a prioritized 30/60/90 roadmap with recommended next steps including the Director AI Oversight Intensive, Advisory services, or Subscription support."
      }
    ]
  };

  return (
    <>
      <JsonLd data={quizData} />
      <JsonLd data={howToData} />
    </>
  );
};

export default QuizSchema;
